/** @format */

import categoryBeauty from './images/category-beauty.png';
import categoryPersonalCare from './images/category-personal-care.png';
import categoryKids from './images/category-kids.png';
import categoryMedications from './images/category-medications.png';
import categoryVitaminsSupplements from './images/category-vitamins-supplements.png';
import categoryVeterinary from './images/category-veterinary.png';

export const HOME_CATEGORIES = [
	{
		label: 'Belleza',
		slug: 'belleza',
		image: categoryBeauty,
		gradientFrom: '#e5a6dc',
		gradientTo: '#c47bbd',
	},
	{
		label: 'Cuidado personal',
		slug: 'cuidado-personal-e-higiene',
		image: categoryPersonalCare,
		gradientFrom: '#b5e09a',
		gradientTo: '#7fc26c',
	},
	{
		label: 'Infantil',
		slug: 'bebe-e-infantil',
		image: categoryKids,
		gradientFrom: '#f3e57d',
		gradientTo: '#d9c43f',
	},
	{
		label: 'Medicamentos',
		slug: 'medicamentos',
		image: categoryMedications,
		gradientFrom: '#9fd3f5',
		gradientTo: '#5ea9e2',
	},
	{
		label: 'Vitaminas y suplementos',
		slug: 'vitaminas-y-suplementos',
		image: categoryVitaminsSupplements,
		gradientFrom: '#f7c97c',
		gradientTo: '#ee9f4c',
	},
	{
		label: 'Veterinaria',
		slug: 'veterinaria',
		image: categoryVeterinary,
		gradientFrom: '#b98bec',
		gradientTo: '#9259d6',
	},
];
